export class KioskClientSecretsRequest {
    kioskId: string;
    tenantId: string;
}